<template>
  <div id="header" style="font-size: 16px">
    <div class="flex items-center">
      <div class="pl-6 flex flex-1 hidden md:!flex" />
      <a class="mx-auto my-2.5 pl-2.5 md:pl-0" :href="logoUrl">
        <img style="height: 40px" src="/resources/_levity/svg/black-logo.svg" alt="Levity logo" />
      </a>
      <div class="pr-2.5 md:pr-6 flex flex-1 justify-end"><AccountMenu v-if="isLoggedIn == 'true'" /></div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import AccountMenu from "./components/AccountMenu.vue";

export default Vue.extend({
  props: {
    logoUrl: { type: String, required: true },
    isLoggedIn: { type: String, required: true },
  },
  components: {
    AccountMenu,
  },
});
</script>

<style scoped>
@tailwind base;
@tailwind components;
@tailwind utilities;
</style>

<style lang="scss" scoped>
@import "@theme/Main.scss";
</style>
